<div class="row mt-2">
    <div class="col-md-6 col-lg-3">
        <globalinformaciongeneral></globalinformaciongeneral>
    </div>
    <div class="col-md-6 col-lg-3">
        <mat-card class="afiliaciones">
            <mat-card-header>
                <div mat-card-avatar class="iconafiliados"><img src="../../../assets/img/totalafiliados.png" alt=""></div>
                <mat-card-subtitle>Total afiliados</mat-card-subtitle>
                <mat-card-title>Activos</mat-card-title>
            </mat-card-header>
            <mat-card-content class="afiliacionescontenido">
                <div class="afiliados">
                    <h4>{{this.descripcionTotalMesAnterior}}</h4>
                    <mat-icon aria-hidden="false" aria-label="Example home icon">expand_less</mat-icon>
                </div>
                <div class="porcentan">
                    <p class="badge rounded-pill bg-badge" *ngIf="this.mostrarCargando">
                        ...
                    </p>
                    <p class="badge rounded-pill bg-badge" [ngStyle]="{'color': ColorPorcentajeTotalMesAnterior()}" *ngIf="!this.mostrarCargando">
                        {{this.porcentajeTotalMesAnterior
                        <=0 ? '' : '+'}} {{this.porcentajeTotalMesAnterior}}% </p>
                            <p>frente al periodo anterior</p>
                </div>
            </mat-card-content>
        </mat-card>
    </div>

    <div class="col-md-6 col-lg-3">
        <mat-card class="afiliaciones">
            <mat-card-header>
                <div mat-card-avatar class="iconafiliados"><img src="../../../assets/img/nuevosafiliados.png" alt=""></div>
                <mat-card-subtitle>Nuevos</mat-card-subtitle>
                <mat-card-title>Afiliados</mat-card-title>
            </mat-card-header>
            <mat-card-content class="afiliacionescontenido">
                <div class="afiliados">
                    <h4>{{this.descripcionNuevoMesAnterior}}</h4>
                    <mat-icon aria-hidden="false" aria-label="Example home icon">expand_less</mat-icon>
                </div>
                <div class="porcentan">
                    <p class="badge rounded-pill bg-badge" *ngIf="this.mostrarCargando">
                        ...
                    </p>
                    <p class="badge rounded-pill bg-badge" [ngStyle]="{'color': ColorPorcentajeNuevoMesAnterior()}" *ngIf="!this.mostrarCargando">
                        {{this.porcentajeNuevoMesAnterior
                        <=0 ? '' : '+'}} {{this.porcentajeNuevoMesAnterior}}% </p>
                            <p>frente al periodo anterior</p>
                </div>
            </mat-card-content>
        </mat-card>
    </div>

    <div class="col-md-6 col-lg-3 mb-md-4">
        <mat-card class="afiliaciones">
            <mat-card-header>
                <div mat-card-avatar class="iconafiliados"><img src="../../../assets/img/inactivoafiliados.png" alt=""></div>
                <mat-card-subtitle>Afiliados</mat-card-subtitle>
                <mat-card-title>Inactivos</mat-card-title>
            </mat-card-header>
            <mat-card-content class="afiliacionescontenido">
                <div class="afiliados">
                    <h4>{{this.descripcionInactivosMesAnterior}}</h4>
                    <mat-icon aria-hidden="false" aria-label="Example home icon">expand_less</mat-icon>
                </div>
                <div class="porcentan">
                    <p class="badge rounded-pill bg-badge" *ngIf="this.mostrarCargando">
                        ...
                    </p>
                    <p class="badge rounded-pill bg-badge" [ngStyle]="{'color': ColorPorcentajeInactivosMesAnterior()}" *ngIf="!this.mostrarCargando">
                        {{this.porcentajeInactivosMesAnterior
                        <=0 ? '' : '+'}} {{this.porcentajeInactivosMesAnterior}}% </p>
                            <p>frente al periodo anterior</p>
                </div>
            </mat-card-content>
        </mat-card>
    </div>
</div>